var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 29,
    fill: "none",
    viewBox: "0 0 42 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9F9F9F",
    fillRule: "evenodd",
    d: "M34.3636 29H28.6364H23.8636V21.2667H27.6818L21 13.5333L14.3182 21.2667H18.1364V29H13.3636H7.63636C3.41918 29 0 25.5374 0 21.2667C0 17.6552 2.457 14.645 5.76164 13.7963C6.12818 6.11707 12.3728 0 20.0455 0C27.6322 0 33.8253 5.9798 34.3159 13.5391C38.598 13.5082 42 17.0191 42 21.2667C42 25.5374 38.5808 29 34.3636 29Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.d06235b540b37a1511116804869641cd.svg";
export { ForwardRef as ReactComponent };